export const getStoreTitle = (selectedFilters, selectedRegions) => {
  const nonRegionFilters = (selectedFilters || []).filter(
    (f) => f.category !== 'region_slug',
  )
  const getSingleFilter = (category) => {
    const categoryFilters = nonRegionFilters.filter(
      (f) => f.category === category,
    )
    if (categoryFilters.length === 1) {
      return categoryFilters[0]
    }
  }
  let title = null
  const type = getSingleFilter('categories')
  const varietal = getSingleFilter('varietals')
  if (varietal) {
    title = varietal.name
  } else if (type) {
    title = type.name
  }
  let regionsPart = ''
  if (!selectedRegions) {
    regionsPart = ''
  } else if (selectedRegions.length === 1) {
    regionsPart = `from ${selectedRegions[0]}`
  } else if (selectedRegions.length === 2) {
    regionsPart = `from ${selectedRegions[0]} and ${selectedRegions[1]}`
  } else if (selectedRegions.length === 3) {
    regionsPart = `from ${selectedRegions[0]}, ${selectedRegions[1]}, and ${selectedRegions[2]}`
  } else if (selectedRegions.length > 3) {
    regionsPart = `from ${selectedRegions[0]}, ${selectedRegions[1]}, ${selectedRegions[2]} and other regions`
  }
  if (regionsPart) {
    title = `${title || 'Wine'} ${regionsPart}`
  } else if (!title) {
    title = 'All Wines'
  }
  return title
}
